import { render, staticRenderFns } from "./DefaultNumberField.vue?vue&type=template&id=b45d4558"
import script from "./DefaultNumberField.vue?vue&type=script&lang=js"
export * from "./DefaultNumberField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports